import { render, staticRenderFns } from "./TabPostFeed.vue?vue&type=template&id=62f311e4&"
import script from "./TabPostFeed.vue?vue&type=script&lang=js&"
export * from "./TabPostFeed.vue?vue&type=script&lang=js&"
import style0 from "./TabPostFeed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports